import FilterListGlobalList from 'common/pages/filter-list-global/FilterListGlobalList.tsx'

export const FilterListGlobalListAdvertiser = (props: any) => <FilterListGlobalList {...props} />